module.exports = "https://coursera_assets.s3.amazonaws.com/images/560c160ecb7ec709705cbc4d257a77b8.png";